// extracted by mini-css-extract-plugin
export default {"customise-tab":"CustomiseTab_customise-tab__185Xx"};